// import SwipeableViews from "react-swipeable-views";
import { makeStyles } from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";
import { ImQrcode } from "react-icons/im";
import { MdClose } from "react-icons/md";
import { useState } from "react";
import QrReader from "react-qr-reader";
import { Modal, Typography } from "@material-ui/core";
import { navigate } from "@reach/router";
import { validURL } from "../lib/utilities";
import { useLocation } from "@reach/router";

const useStyles = makeStyles((theme) => ({
  position1: {
    display: "flex",
    alignItems: "center",
    position: "fixed",
    top: 170,
    right: theme.spacing(0.5),
    zIndex: 2,
  },
  position2: {
    display: "flex",
    alignItems: "center",
    position: "fixed",
    bottom: 65,
    right: theme.spacing(0.5),
    zIndex: 2,
  },
  labels: {
    display: "flex",
    flexDirection: "column",
    marginRight: theme.spacing(1),
  },
  title: {
    marginBottom: theme.spacing(-1),
    textAlign: "right",
    fontWeight: 600,
  },
  subtitle: {
    letterSpacing: 0.6,
    textAlign: "right",
    fontWeight: 600,
  },
  icon: {
    fontSize: "1.5rem",
  },
  paper: {
    width: "70%",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    borderRadius: 8,
  },
  modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  video: {
    width: "100%",
    height: "100%",
  },
  qrTitel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

function QRCodeButton({ showText }) {
  const classes = useStyles();
  let suburl = false;
  const location = useLocation();

  const [open, setOpen] = useState(false);
  // we need this in state, otherwise facingMode defaults to "user", nobody knows why :D
  const [facingMode] = useState("environment");

  const handleScan = (data) => {
    const stationNrRegex = /(stationen\/)([0-9]+)/;
    const stationNrRegex2 = /(fitnesstrail)([0-9]+)/;
    const url = data;

    if (data && validURL(url)) {
      // we can delete this part as soon as we get a fix URL
      if (stationNrRegex.test(url)) {
        const stNr = url.match(stationNrRegex)[2];
        setOpen(false);
        navigate(`/stationen/${stNr}?verified=true`);
      } else if (stationNrRegex2.test(url)) {
        const stNr2 = url.match(stationNrRegex2)[2];
        setOpen(false);
        navigate(`/stationen/${stNr2}?verified=true`);
      } else {
        setOpen(false);
        navigate(url);
      }
    }
  };

  const handleError = (err) => {
    console.error(err);
  };

  const closeModal = () => {
    setOpen(false);
  };

  const openModal = () => {
    setOpen(true);
  };

  if (location.pathname.match("stationen/")) {
    suburl = true;
  }

  return (
    <div className={suburl ? classes.position2 : classes.position1}>
      {showText && (
        <div className={classes.labels}>
          <Typography component="h3" variant="h6" color="primary" className={classes.title}>
            Code scannen
          </Typography>
          <Typography component="h3" variant="caption" color="primary" className={classes.subtitle}>
            Station verifizieren
          </Typography>
        </div>
      )}
      <Fab
        alt="QR-Code scannen"
        aria-label="QR-Code-sannen"
        color="primary"
        onClick={() => openModal()}
      >
        <ImQrcode className={classes.icon} />
      </Fab>
      <Modal
        open={open}
        onClose={closeModal}
        aria-labelledby="modal-for-qr-scanning"
        aria-describedby="scan-qr-code"
        className={classes.modal}
      >
        <div className={classes.paper}>
          <>
            <h2 className={classes.qrTitel}>
              <span style={{ marginLeft: 10 }}>QR-Code scannen</span>
              <MdClose
                className={classes.icon}
                onClick={() => closeModal()}
                style={{ paddingLeft: "12px" }}
              />
            </h2>
            <QrReader
              delay={300}
              facingMode={facingMode}
              className={classes.video}
              onError={handleError}
              onScan={handleScan}
            />
          </>
        </div>
      </Modal>
    </div>
  );
}

export default QRCodeButton;
